// material-ui
import { useTheme } from '@mui/material/styles';
import sasLogo from 'assets/images/users/saslogo.png';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse, ...others }) {
  const theme = useTheme();
  return (
    <img src={sasLogo} alt="Food Delivery Admin" height="40" style={{ objectFit: 'contain' }} {...others} />
  );
}
